
// // import React from "react";

// // const HeroSlide = ({ active = false, title, subtitle, img }) => (
// //   <div className={`carousel-item ${active ? "active" : ""}`}>
// //     <img src={img} className="w-100 object-fit-cover" alt={title} style={{ maxHeight: 520 }} />
// //     <div className="carousel-caption d-none d-md-block text-start">
// //       <h1 className="fw-bold">{title}</h1>
// //       <p className="lead">{subtitle}</p>
// //       <div className="d-flex gap-2">
// //         <a href="#register" className="btn btn-primary-navbar-reg">Register Your Community</a>
// //         <a href="#features" className="btn btn-primary-navbar-login">Explore Features</a>
// //       </div>
// //     </div>
// //   </div>
// // );

// // const HeroCarousel = () => (
// //   <section aria-label="Hero" className="bg-light">
// //     <div id="heroCarousel" className="carousel slide" data-bs-ride="carousel">
// //       <div className="carousel-indicators">
// //         <button type="button" data-bs-target="#heroCarousel" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
// //         <button type="button" data-bs-target="#heroCarousel" data-bs-slide-to="1" aria-label="Slide 2"></button>
// //         <button type="button" data-bs-target="#heroCarousel" data-bs-slide-to="2" aria-label="Slide 3"></button>
// //       </div>

// //       <div className="carousel-inner">
// //         <HeroSlide
// //           active
// //           title="Manage Your Gated Community, Effortlessly"
// //           subtitle="Events, elections, notices, security, entry passes & complaints—all in one app."
// //           img="https://picsum.photos/1200/520?random=101"
// //         />
// //         <HeroSlide
// //           title="Smart Security & Visitor Management"
// //           subtitle="Generate entry passes, verify visitors, and keep your campus secure."
// //           img="https://picsum.photos/1200/520?random=102"
// //         />
// //         <HeroSlide
// //           title="Engage Residents with Events & Announcements"
// //           subtitle="Create events, publish notices, and keep everyone informed."
// //           img="https://picsum.photos/1200/520?random=103"
// //         />
// //       </div>

// //       <button className="carousel-control-prev" type="button" data-bs-target="#heroCarousel" data-bs-slide="prev">
// //         <span className="carousel-control-prev-icon" aria-hidden="true"></span>
// //         <span className="visually-hidden">Previous</span>
// //       </button>
// //       <button className="carousel-control-next" type="button" data-bs-target="#heroCarousel" data-bs-slide="next">
// //         <span className="carousel-control-next-icon" aria-hidden="true"></span>
// //         <span className="visually-hidden">Next</span>
// //       </button>
// //     </div>
// //   </section>
// // );

// // export default HeroCarousel;


// // HeroCarousel.js
// import React from "react";

// const slides = [
//   {
//     title: "Run Your Community Like a Pro",
//     subtitle: "Events, elections, notices – all in one place.",
//     img: "https://picsum.photos/1200/600?random=11",
//     ctas: [
//       { href: "#register", label: "Register Your Community" },
//       { href: "#features", label: "Explore Features" },
//     ],
//   },
//   {
//     title: "Built for RWAs & Societies",
//     subtitle: "From maintenance to polls, get it done faster.",
//     img: "https://picsum.photos/1200/600?random=12",
//     ctas: [{ href: "#features", label: "See How It Works" }],
//   },
// ];

// const HeroSlide = ({ s }) => (
//   <div
//     className="hero-slide"
//     style={{ backgroundImage: `url(${s.img})` }}
//     role="group"
//     aria-label={s.title}
//   >
//     <div className="hero-overlay">
//       <h2 className="hero-title">{s.title}</h2>
//       <p className="hero-sub">{s.subtitle}</p>
//       <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
//         {s.ctas?.map((c) => (
//           <a key={c.label} className="btn" href={c.href}>
//             {c.label}
//           </a>
//         ))}
//       </div>
//     </div>
//   </div>
// );

// const HeroCarousel = () => {
//   return (
//     <section className="section container" aria-label="Highlights">
//       <div className="hero-rail">
//         {slides.map((s, i) => (
//           <HeroSlide key={i} s={s} />
//         ))}
//       </div>
//     </section>
//   );
// };

// export default HeroCarousel;

import React, { useEffect, useRef, useState } from "react";
import "./hero.mobile.css"; // <= new CSS for the mobile rail

// Shared slide data (used by both views)
const slides = [
  {
    title: "Manage Your Gated Community, Effortlessly",
    subtitle: "Events, elections, notices, security, entry passes & complaints—all in one app.",
    img: "https://picsum.photos/1200/520?random=101",
    ctas: [
      { href: "#register", label: "Register Your Community", className: "btn btn-primary-navbar-reg" },
      { href: "#features", label: "Explore Features", className: "btn btn-primary-navbar-login" },
    ],
  },
  {
    title: "Smart Security & Visitor Management",
    subtitle: "Generate entry passes, verify visitors, and keep your campus secure.",
    img: "https://picsum.photos/1200/520?random=102",
    ctas: [
      { href: "#register", label: "Register Your Community", className: "btn btn-primary-navbar-reg" },
      { href: "#features", label: "Explore Features", className: "btn btn-primary-navbar-login" },
    ],
  },
  {
    title: "Engage Residents with Events & Announcements",
    subtitle: "Create events, publish notices, and keep everyone informed.",
    img: "https://picsum.photos/1200/520?random=103",
    ctas: [
      { href: "#register", label: "Register Your Community", className: "btn btn-primary-navbar-reg" },
      { href: "#features", label: "Explore Features", className: "btn btn-primary-navbar-login" },
    ],
  },
];

/** Desktop Bootstrap slide (unchanged UI) */
const DesktopHeroSlide = ({ active = false, title, subtitle, img, ctas }) => (
  <div className={`carousel-item ${active ? "active" : ""}`}>
    <img
      src={img}
      className="w-100 object-fit-cover"
      alt={title}
      style={{ maxHeight: 520 }}
      loading="eager"
    />
    <div className="carousel-caption d-none d-md-block text-start">
      <h1 className="fw-bold">{title}</h1>
      <p className="lead">{subtitle}</p>
      <div className="d-flex gap-2 flex-wrap">
        {ctas?.map((c) => (
          <a key={c.label} href={c.href} className={c.className}>
            {c.label}
          </a>
        ))}
      </div>
    </div>
  </div>
);

/** Mobile slide card */
const MobileHeroCard = ({ s }) => {
  return (
    <div
      className="hero-slide"
      style={{ backgroundImage: `url(${s.img})` }}
      role="group"
      aria-label={s.title}
    >
      <div className="hero-overlay">
        <h2 className="hero-title">{s.title}</h2>
        <p className="hero-sub">{s.subtitle}</p>
        <div className="hero-ctas">
          {s.ctas?.map((c) => (
            <a
              key={c.label}
              href={c.href}
              className="btn hero-chip"
              onPointerDown={(e) => {
                const rect = e.currentTarget.getBoundingClientRect();
                e.currentTarget.style.setProperty("--x", `${((e.clientX - rect.left) / rect.width) * 100}%`);
                e.currentTarget.style.setProperty("--y", `${((e.clientY - rect.top) / rect.height) * 100}%`);
              }}
            >
              <span className="hero-chip-ripple" aria-hidden="true" />
              {c.label}
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

const HeroCarousel = () => {
  // Track current mobile slide for accessible indicators
  const [current, setCurrent] = useState(0);
  const railRef = useRef(null);

  // Update indicator based on scroll position
  useEffect(() => {
    const rail = railRef.current;
    if (!rail) return;

    const onScroll = () => {
      const w = rail.clientWidth;
      const idx = Math.round(rail.scrollLeft / w);
      setCurrent(idx);
    };
    rail.addEventListener("scroll", onScroll, { passive: true });
    return () => rail.removeEventListener("scroll", onScroll);
  }, []);

  const scrollToIndex = (i) => {
    const rail = railRef.current;
    if (!rail) return;
    rail.scrollTo({ left: i * rail.clientWidth, behavior: "smooth" });
    setCurrent(i);
  };

  return (
    <section aria-label="Hero" className="bg-light">
      {/* --- MOBILE (< md): swipeable rail --- */}
      <div className="d-md-none container py-3">
        <div
          className="hero-rail"
          ref={railRef}
          aria-live="polite"
          aria-label={`Slide ${current + 1} of ${slides.length}`}
        >
          {slides.map((s, i) => (
            <MobileHeroCard key={i} s={s} />
          ))}
        </div>

        {/* Indicators (tap to navigate) */}
        <div className="hero-dots" role="tablist" aria-label="Hero navigation">
          {slides.map((_, i) => (
            <button
              key={i}
              type="button"
              className={`hero-dot ${current === i ? "is-active" : ""}`}
              aria-label={`Go to slide ${i + 1}`}
              aria-current={current === i ? "true" : "false"}
              onClick={() => scrollToIndex(i)}
            />
          ))}
        </div>
      </div>

      {/* --- DESKTOP/TABLET (≥ md): Bootstrap carousel (unchanged) --- */}
      <div id="heroCarousel" className="carousel slide d-none d-md-block" data-bs-ride="carousel">
        <div className="carousel-indicators">
          {slides.map((_, i) => (
            <button
              key={i}
              type="button"
              data-bs-target="#heroCarousel"
              data-bs-slide-to={i}
              className={i === 0 ? "active" : ""}
              aria-current={i === 0 ? "true" : "false"}
              aria-label={`Slide ${i + 1}`}
            />
          ))}
        </div>

        <div className="carousel-inner">
          {slides.map((s, i) => (
            <DesktopHeroSlide
              key={i}
              active={i === 0}
              title={s.title}
              subtitle={s.subtitle}
              img={s.img}
              ctas={s.ctas}
            />
          ))}
        </div>

        <button className="carousel-control-prev" type="button" data-bs-target="#heroCarousel" data-bs-slide="prev">
          <span className="carousel-control-prev-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Previous</span>
        </button>
        <button className="carousel-control-next" type="button" data-bs-target="#heroCarousel" data-bs-slide="next">
          <span className="carousel-control-next-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Next</span>
        </button>
      </div>
    </section>
  );
};

export default HeroCarousel;
